import React from "react";
import styled from "styled-components";
import { Spacing } from "@glossy";
import Icon from "@ui-kit/icon";
import { Influencer } from "@radarly/models/influencer";

interface IProps {
  platform: Influencer["platform"];
  className?: string;
}

const Root = styled.div`
  position: absolute;
  left: ${Spacing.Large};
  bottom: ${Spacing.Large};
  display: flex;
  align-items: center;
  gap: ${Spacing.ExtraSmall};
`;

const PlatformLabel = styled.p`
  display: inline-block;
  vertical-align: middle;
  text-transform: capitalize;
`;

const RadarlyAuthorPlatform = ({ platform, className }: IProps) => {
  return (
    <Root>
      <Icon glyph={platform} size={16} />
      <div>
        <PlatformLabel>{platform}</PlatformLabel>
      </div>
    </Root>
  );
};

export default RadarlyAuthorPlatform;
